import { render, staticRenderFns } from "./DeliveryBlock.vue?vue&type=template&id=85931678&scoped=true"
import script from "./DeliveryBlock.vue?vue&type=script&lang=js"
export * from "./DeliveryBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85931678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85931678')) {
      api.createRecord('85931678', component.options)
    } else {
      api.reload('85931678', component.options)
    }
    module.hot.accept("./DeliveryBlock.vue?vue&type=template&id=85931678&scoped=true", function () {
      api.rerender('85931678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/step1/DeliveryBlock.vue"
export default component.exports